export default /* glsl */ `
float oldy = transformed.y;
transformed.y -= mod(time * 0.5, 8.0);
transformed.y = transformed.y < -4.0 ? transformed.y + 8.0 : transformed.y;

#include <morphtarget_vertex>
`;
